<app-list-view
  [service]="userService"
  [disableEdit]="true"
  [url]="'editUser'"
  [newUrl]="'user/editUser/0'"
  [displayedColumns]="['displayName', 'userName']"
></app-list-view>
